import {ConversionResidents} from './ConversionResidents';

export class SourceSession {
  sourceEnvironmentId: string;
  sourceEnvironmentName: string;
  sourceCorporationId: string;
  sourceCorporationName: string;
  sourceFacilityId: string;
  sourceFacilityName: string;
  sourceUnitId: string[];
  sourceDocTypes: string[];
  dateRange: string
  residents: ConversionResidents[] = [];
}
